export default __webpack_public_path__ + "static/media/send_mass_mail.f68819a5.png";